import React, { Component } from 'react';
import T from 'i18n-react';
// Composants
import AutoCompleteInput from '../autoCompleteInput/AutoCompleteInput';
import DatePicker from 'material-ui/DatePicker';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { RaisedButton } from 'material-ui';
import CheckBoxIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';
// Style
import './ReportingHeader.css';
// Service
import ShopService from '../../services/ShopService'
// Enum
import COLORS from '../../enums/ColorEnum';
import PROFILES from '../../enums/ProfileEnum';
import Location from '../../enums/Location';
import LOCATIONS from "../../enums/Location";
import { getDistinctValues } from "../../utils/JSUtils";
// Utils
import {getCorrectDefaultDateFormat} from '../../utils/DateUtils';
import SelectField from 'material-ui/SelectField';
import CardType from "../../enums/CardType";
import Collapsible from "react-collapsible";

/**
 * Composant affichant le haut du tableau : Nom de la bu, Nom du magasin et date picker
 */
class ReportingHeader extends Component {

    ALL_SHOP_OPTION = {
        id: 0,
        name: T.translate("tableHeader.allShop")
    };

    /**
     * @param {*} props contient :
     *  - une action lors du changement de Date
     *  - Le nom de la BU
     *  - le nom du magasin
     */
    constructor(props) {
        super(props);
        let defaultDate = getCorrectDefaultDateFormat(props.defaultDate);

        let selectedShop = null;
        if (props.initFilters.selectedShop) {
            const shop = this.getItemInList({name: props.initFilters.selectedShop[0].name.split(' - ')[1] ? props.initFilters.selectedShop[0].name.split(' - ')[1] : props.initFilters.selectedShop[0].name}, props.shopList);
            if (shop) {
                selectedShop = this.mapShopToShopDisplay(shop);
            } else {
                props.shopAction(null);
            }
        }
        if (!selectedShop && (props.buList.length === 1 || props.initFilters.selectedBu)) {
            //Si l'utilisateur n'a qu'une BU, on présélectionne le champ 'Tous les magasins' et la bu
            selectedShop = this.ALL_SHOP_OPTION;
        }

        let selectedClient = null;
        if (props.initFilters.selectedClient) {
            const client = this.getItemInList(props.initFilters.selectedClient[0], props.clientList);
            if (client) {
                selectedClient = client;
            } else {
                props.clientAction(null)
            }
        }

        let selectedBu = null;
        if (selectedClient && props.initFilters.selectedBu) {
            const bu = this.getItemInList(props.initFilters.selectedBu[0], props.buList);
            if (bu) {
                selectedBu = bu;
            } else {
                props.buAction(null)
            }
        }

        this.state = {
            buCountry: props.initFilters.location ? props.initFilters.location[0] : props.location,
            clientList: props.clientList,
            buList: props.buList,
            shopList: props.shopList,
            streamTypeList: props.streamTypeList,
            cardTypes: props.cardTypes,
            activities: props.activities,
            selectedStreamType: null,
            streamTypeAction: props.streamTypeAction,
            date: defaultDate,
            shopAction: props.shopAction,
            financingList: props.financingList,
            financingAction: props.financingAction,
            selectedFinancingDate: null,
            buAction: props.buAction,
            clientAction: props.clientAction,
            cardTypeAction: props.cardTypeAction,
            activityAction: props.activityAction,
            selectedBu: selectedBu,
            selectedClient: selectedClient,
            selectedShop: selectedShop,
            cleanData: props.cleanData,
            allShopList: props.allShopList,
            displayAllShop: false,
            activitiesSelected: props.initFilters.selectedActivity,
            cardTypesSelected: props.initFilters.selectedPaymentType,
            isOpenFilters: props.initFilters.isOpenReportingFilter
        }
    }

    componentWillReceiveProps(newProps) {
        const defaultDate = getCorrectDefaultDateFormat(newProps.defaultDate);
        this.setState((state) => ({
            date: defaultDate,
            buList: newProps.buList,
            shopList: newProps.shopList,
            streamTypeList: newProps.streamTypeList,
            streamTypeAction: newProps.streamTypeAction,
            cardTypes: newProps.cardTypes,
            activities: newProps.activities,
            financingList: newProps.financingList,
            selectedBu: newProps.buList.length === 1 ? newProps.buList[0]: state.selectedBu,
            buAction: newProps.buAction,
            allShopList: newProps.allShopList,
            //Si l'utilisateur n'a qu'une BU, on présélectionne le champ 'Tous les magasins'
            selectedShop: (newProps.buList.length === 1 && state.selectedShop === null) ? this.ALL_SHOP_OPTION : state.selectedShop,
            displayAllShop: false,
            isOpenFilters: newProps.initFilters.isOpenReportingFilter
        }));
    }

    getItemInList(value, list) {
        if (list && value.name) {
            return list.find(item => item.name === value.name)
        }

        return null
    }

    render() {
        return (
            <div className="reporting-header">
                <Collapsible trigger={T.translate('transactionPage.filters')}
                             open={this.state.isOpenFilters}
                             onTriggerOpening={() => this.toggleFilters(true)} onTriggerClosing={() => this.toggleFilters(false)}>
                    <div className="filterContainer">
                        {this.renderBuCountryMenu()}
                        {this.renderClientMenu(this.props.userProfile)}
                        <div>
                            <label>{T.translate("tableHeader.bu")} :</label>{this.renderBuMenuItem()}
                        </div>
                        {this.renderShopMenuItem()}
                        {this.renderStreamTypeMenuItem()}
                        {this.props.userProfile !== PROFILES.USER ? <div className="transactionContainerButtons">
                            <RaisedButton className="buttonAction secondary-button" label={T.translate("transactionPage.filter.reset")} secondary
                                onClick={this.resetFilters.bind(this)}>
                            </RaisedButton>
                        </div> : null}
                    </div>
                    {this.state.buCountry === LOCATIONS.BE || this.state.buCountry === LOCATIONS.FR || this.state.selectedBu || (this.state.shopList && this.state.shopList.length < 2) || (this.state.financingList && this.state.financingList.length > 1) ?
                        <div className="filterContainer">
                            {this.state.buCountry === LOCATIONS.BE ? this.renderCardTypesDropDown() : null}
                            {this.state.buCountry === LOCATIONS.FR ? this.renderActivityDropDown() : null}
                            {this.state.selectedBu || (this.state.shopList && this.state.shopList.length < 2) ?
                                <div>
                                    <label>{T.translate("tableHeader.date")} :</label>
                                    <DatePicker
                                        name="date-picker-reporting"
                                        className="datePickerHeader"
                                        value={this.state.date}
                                        underlineStyle={{ display: 'none' }}
                                        onChange={this.onChangeDate.bind(this)}
                                    />
                                </div>
                                :
                                null
                            }
                            {this.state.financingList && this.state.financingList.length > 1 ?
                                <div className='tableHeaderFinancingList'>
                                    <label>{T.translate("tableHeader.financing")} :</label>{this.renderFinancingMenu()}
                                </div>
                                :
                                null
                            }
                        </div>
                        : null}
                </Collapsible>
            </div>
        );
    }

    toggleFilters = (isOpen) => {
        this.setState({isOpenFilters: isOpen});
        this.props.openAction(isOpen);
    }

    /**
     * Retourne les configurations de style de l'input d'autocompletion
     * @returns {Object}
     */
    getAutoCompleteConfigs = () => {
        return {
            input: {
                color: COLORS.BLACK,
                textFieldStyle: {
                    color: COLORS.BLACK,
                    textareaStyle: {
                        color: COLORS.BLACK
                    }
                },
                underlineShow: this.props.userProfile === PROFILES.ADMIN_MP,
                underlineStyle: {
                    width: 'calc(100% + 24px)'
                }
            }
        };
    };

    /**********************************************************
     ********************* User Action *************************
     **********************************************************/

    /**
     * Action au changement du type d'entité ( ES - BE - FR)
     */
    onChangeCountry(event, index, value) {
        this.setState({
                buCountry : value,
                selectedBu: null,
                selectedClient: null,
                selectedFinancingDate: null,
                selectedStreamType: null,
                selectedShop: null,
            cardTypesSelected: null,
            activitiesSelected: null
            }, this.state.cleanData(value));
    }

    /**
     * Action au changement de client
     * @param client
     */
    onchangeClient = (client) => {
        this.setState({
                selectedClient: client,
                selectedBu: null,
                selectedFinancingDate: null,
                selectedStreamType: null,
                selectedShop: null,
        }, this.state.clientAction(client));
    };

    /**
     * Action au changement de bu
     * @param bu
     */
    onchangeBu = (bu) => {
        const selectedClient = this.state.clientList.find(client => client.id === bu.idClient)
        this.setState((state) => ({
            selectedClient: selectedClient,
            selectedBu: bu,
            selectedShop: this.ALL_SHOP_OPTION,
            selectedFinancingDate: null
        }));

        this.state.buAction(bu, selectedClient);
    };

    /**
     * Action au changement de shop
     * @param {*} shop
     */
    onChangeShop = (shop) => {
        if (shop.id !== 0) {
            ShopService.getAssociatedBuList(shop.id).then((listBu) => {
                let associatedBu = null;
                if (listBu.length > 0) {
                    //Si on a une bu sélectionnée et que le magasin choisi a cette bu parmi ses bu associé on prend cette bu (utile si plusieurs bu pour un magasin en admin)
                    if (this.state.selectedBu && this.state.selectedBu.id && listBu.map(bu => bu.id).includes(this.state.selectedBu.id)) {
                        associatedBu = this.state.selectedBu;
                    } else {
                        //Sinon on prend la première bu
                        associatedBu = listBu[0]
                    }
                }
                const selectedClient = this.state.clientList.find(client => client.id === associatedBu.idClient)
                this.setState((state) => ({
                    selectedClient: selectedClient,
                    selectedBu: associatedBu,
                    selectedShop: shop,
                    selectedFinancingDate: null
                }), this.state.shopAction(shop, associatedBu, selectedClient))
            });
        } else {
            // Si l'utilisateur selectionne tous les magasins alors on reset le selected shop
            this.setState({
                selectedShop: shop,
                selectedFinancingDate: null
            }, this.state.shopAction(null))
        }
    };

    /**
     * Action au changement de type de flux
     */
    onChangeStreamType = (event, key, value) => {
        this.setState({ selectedStreamType: value });
        this.state.streamTypeAction(value);
    };

    onChangeFincancing(event, index, value) {
        let financingDate = value;

        if(value.includes("ALL")) {
            if (this.state.financingList.every(item => value.includes(item))) {
                financingDate = [];
            } else {
                financingDate = this.state.financingList;
            }
            // Récupération des operations de tous les magasins
        }
        this.state.financingAction(financingDate);
        this.setState({selectedFinancingDate: financingDate})
    }

    onChangeDate(event, date) {
        this.setState({selectedFinancingDate: null});
        this.props.dateAction(date);
    }

    resetFilters() {
        this.state.cleanData()
        this.setState(() => ({
            buCountry: null,
            selectedClient: null,
            selectedBu: null,
            selectedShop: null,
            displayAllShop: false,
            cardTypesSelected: null,
            activitiesSelected: null,
            selectedFinancingDate: null
        }));
    }


    /**********************************************************
     ******************* Render List items *********************
     **********************************************************/

    /**
     * Permet d'afficher le menu de selection de client
     */
    renderClientMenu(userProfile) {
        if (PROFILES.ADMIN_MP === userProfile || PROFILES.ADMIN === userProfile) {

            // Si on a plusieurs shop on crée un menu drop down
            if (this.state.clientList && this.state.clientList.length > 1) {
                const clientAutoCompleteConfigs = this.getAutoCompleteConfigs();
                const clientDataSource = this.state.clientList.filter(client => client.location === this.state.buCountry);
                return (
                    <div>
                        <label>{T.translate("tableHeader.client")} :</label>
                        <AutoCompleteInput
                            name="client"
                            dataSource={clientDataSource.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                            hintText={T.translate('tableHeader.selectClient')}
                            selectItem={this.onchangeClient}
                            configs={clientAutoCompleteConfigs}
                            itemDisplayed={this.state.selectedClient}
                        />
                    </div>
                );
            } else if (this.state.clientList) { // Sinon on affiche juste le nom du client
                const client = this.state.clientList[0];
                return (
                    <div>
                        <label>{T.translate("tableHeader.client")} :</label>
                        <div className="tableHeader-value">{client.name}</div>
                    </div>
                );
            }
        } else {
            return null;
        }
    }

    /**
     * Affichage de la liste des bu
     */
    renderBuMenuItem() {
        // Si il n'y a pas de buList on quitte la fonction
        if (!this.state.buList) {
            return null;
        }
        // Si on est user on a une seule bu
        // donc on affiche son nom et c'est tout
        if (this.state.buList.length === 1) {
            const bu = this.state.buList[0];
            return (
                <div>
                    {bu.name}
                </div>
            );
        }

        // Cette partie ne se fait que si l'on est admin
        // Si l'on est admin on doit afficher un dropdown autocompletable
        const buAutoCompleteConfigs = this.getAutoCompleteConfigs();
        let buDataSource;
        if (this.state.selectedClient) {
            buDataSource = this.state.buList.filter(bu => bu.idClient === this.state.selectedClient.id);
        } else {
            buDataSource = this.state.buList.filter(bu => bu.location === this.state.buCountry);
        }

        return (
            <AutoCompleteInput
                name="bu"
                dataSource={buDataSource.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                hintText={T.translate('tableHeader.selectBu')}
                selectItem={this.onchangeBu}
                configs={buAutoCompleteConfigs}
                itemDisplayed={this.state.selectedBu}
            />
        );
    }

    /**
     * Permet d'afficher le menu de selection de pays ( utilisé uniquement par les adminMP )
     */
    renderBuCountryMenu() {
        if (this.props.userProfile === PROFILES.ADMIN_MP) {
            //Exctraction des différents pays de l'utilisateur (Cas: un ou plusieurs pays n'a pas de client)
            let locationList = getDistinctValues(this.props.clientList.map(client => client.location));

            return (
                <div>
                    <label>{T.translate('tableHeader.country')} :</label>
                    <DropDownMenu className='tableHeader-shop'
                        value={this.state.buCountry}
                        onChange={this.onChangeCountry.bind(this)}
                        disabled={locationList.length === 1}
                    >
                        <MenuItem key={Location.BE} id={Location.BE} value={Location.BE} primaryText={Location.BE} disabled={!locationList.some(location => location === LOCATIONS.BE)} />
                        <MenuItem key={Location.ES} id={Location.ES} value={Location.ES} primaryText={Location.ES} disabled={!locationList.some(location => location === LOCATIONS.ES)} />
                        <MenuItem key={Location.FR} id={Location.FR} value={Location.FR} primaryText={Location.FR} disabled={!locationList.some(location => location === LOCATIONS.FR)} />
                    </DropDownMenu>
                </div>
            )
        }
    }

    /**
     * Affichage de la liste des magasins
     */
    renderShopMenuItem() {
        if (!this.state.shopList) {
            return null;
        }
        // Si on a plusieurs shop on crée un menu drop down
        if ((this.state.shopList && this.state.shopList.length > 1) || (this.state.allShopList && this.state.allShopList.length > 1)) {
            const shopAutoCompleteConfigs = this.getAutoCompleteConfigs();
            let shopDataSource;
            if (this.state.displayAllShop) {
                shopDataSource = this.state.allShopList.filter(shop => shop.location === this.state.buCountry).sort((a, b) => (a.name > b.name) ? 1 : -1).map(shop => this.mapShopToShopDisplay(shop));
            } else {
                shopDataSource = this.state.shopList.filter(shop => shop.location === this.state.buCountry).sort((a, b) => (a.name > b.name) ? 1 : -1).map(shop => this.mapShopToShopDisplay(shop));
            }
            //Ajout de l'option 'Tous les magasins' en première position dans la liste
            shopDataSource.unshift(this.ALL_SHOP_OPTION);
            return (
                <div>
                    <label>{T.translate("tableHeader.shop")} :</label>
                    <AutoCompleteInput
                        name="shop"
                        dataSource={shopDataSource}
                        hintText={T.translate('tableHeader.selectShop')}
                        selectItem={this.onChangeShop}
                        configs={shopAutoCompleteConfigs}
                        itemDisplayed={this.state.selectedShop}
                        onUpdateInput={this.onUpdateShop.bind(this)}
                    />
                </div>
            );
        } else if (this.state.shopList) { // Sinon on affiche juste le nom du shop
            const shop = this.state.shopList[0];
            return (
                <div>
                    <label>{T.translate("tableHeader.shop")} :</label>
                    <div className="tableHeader-value">{shop.name}</div>
                </div>
            )
        }
    }

    /**
     * Cette fonction est passée au composant autoComplete pour gérer la modification du champ de recherche
     * Si le texte de recherche fait plus de 1 caractère, la recherche s'effectue sur toutes les bu disponibles
     */
    onUpdateShop(value) {
        this.setState({ displayAllShop: !!(value && value.length > 1) })
    }

    mapShopToShopDisplay(shop) {
        return {
            id: shop.id,
            name: shop.codeAl + " - " + shop.name
        }
    }

    /**
     * Affichage de la liste des types de flux (PASS, Carte Bancaires ..) utilisés pour la France
     */
    renderStreamTypeMenuItem() {
        if (!this.state.streamTypeList || this.state.streamTypeList.length < 2) {
            return null;
        }

        return (
            <div>
                <label>{T.translate('tableHeader.streamType')} :</label>
                <DropDownMenu className='tableHeader-streamType'
                    value={this.state.selectedStreamType}
                    onChange={this.onChangeStreamType}>
                    <MenuItem key="DEFAULT" id="DEFAULT" value={null} primaryText={T.translate("tableHeader.selectStreamType")} />
                    {this.state.streamTypeList.map(([itemKey, itemValue]) => <MenuItem key={itemKey} id={itemValue.code} value={itemValue} primaryText={T.translate(itemValue.i18nCode)} />)}
                </DropDownMenu>
            </div>
        );
    }

    /**
     * Affichage de la liste des financements
     */
    renderFinancingMenu() {
        return (
                <SelectField className='tableHeader-activity'
                            multiple={true}
                            hintText={T.translate('transactionPage.filter.allFemale')}
                            hintStyle={{textTransform: 'initial'}}
                            value={this.state.selectedFinancingDate}
                            onChange={(event, key, value) => this.onChangeFincancing(event, key, value)}
                             dropDownMenuProps={{
                                 anchorOrigin: {
                                     vertical: "bottom",
                                     horizontal: "left"
                                 },
                             }}>
                   <MenuItem
                       style={{textTransform: 'capitalize'}}
                       key="ALL"
                       checked={this.allFinancingSelected()}
                       value={"ALL"}
                       primaryText={T.translate('transactionPage.filter.allFemale')}
                       leftIcon={!(this.allFinancingSelected()) ? <CheckBoxIcon/> : null}
                   />
                   {this.state.financingList.map((value) => (
                       <MenuItem
                           style={{textTransform: 'capitalize'}}
                           key={value}
                           checked={this.state.selectedFinancingDate && this.state.selectedFinancingDate.includes(value)}
                           value={value}
                           primaryText={(value === null || value === '') ? 'N/A' : value}
                           leftIcon={!(this.state.selectedFinancingDate && this.state.selectedFinancingDate.includes(value)) ? <CheckBoxIcon/> : null}
                       />))
                   }
               </SelectField>
        )
    }

    /**
     * Permet d'afficher le menu de selection de type de carte
     */
    renderCardTypesDropDown() {
        return(
            <div>
                <label>{T.translate('tableHeader.cardType')} :</label>
                <SelectField className='tableHeader-cardType'
                             multiple={true}
                             hintText={T.translate('transactionPage.filter.allFemale')}
                             hintStyle={{textTransform: 'initial'}}
                             value={this.state.cardTypesSelected}
                             onChange={(event, key, value) => this.handleCardTypeChange(event, key, value)}
                             dropDownMenuProps={{
                                 anchorOrigin: {
                                     vertical: "bottom",
                                     horizontal: "left"
                                 },
                             }}>
                    <MenuItem
                        style={{textTransform: 'capitalize'}}
                        key={"all"}
                        checked={this.allCardTypesSelected()}
                        value={"all"}
                        primaryText={T.translate('transactionPage.filter.allFemale')}
                        leftIcon={!(this.allCardTypesSelected()) ? <CheckBoxIcon/> : null}
                    />
                    {this.props.cardTypes.map((value) => (
                        <MenuItem
                            style={{textTransform: 'capitalize'}}
                            key={value}
                            checked={this.state.cardTypesSelected && this.state.cardTypesSelected.includes(value)}
                            value={value}
                            primaryText={(value === null || value === '') ? 'N/A' : (CardType[value] ? T.translate(CardType[value].name) : value)}
                            leftIcon={!(this.state.cardTypesSelected && this.state.cardTypesSelected.includes(value)) ? <CheckBoxIcon/> : null}
                        />))
                    }
                </SelectField>
            </div>
        );
    }

    allCardTypesSelected() {
        return this.state.cardTypesSelected && this.state.cardTypes.every(arr => this.state.cardTypesSelected.includes(arr));
    }

    /**
     * Permet d'afficher le menu de selection de l'activité
     */
    renderActivityDropDown() {
        return(
            <div>
                <label>{T.translate('tableHeader.activity')} :</label>
                <SelectField className='tableHeader-activity'
                             multiple={true}
                             hintText={T.translate('transactionPage.filter.allFemale')}
                             hintStyle={{textTransform: 'initial'}}
                             value={this.state.activitiesSelected}
                             onChange={(event, key, value) => this.handleActivityChange(event, key, value)}
                             dropDownMenuProps={{
                                 anchorOrigin: {
                                     vertical: "bottom",
                                     horizontal: "left"
                                 },
                             }}>
                    <MenuItem
                        style={{textTransform: 'capitalize'}}
                        key={"all"}
                        checked={this.allActivitiesSelected()}
                        value={"all"}
                        primaryText={T.translate('transactionPage.filter.allFemale')}
                        leftIcon={!(this.allActivitiesSelected()) ? <CheckBoxIcon/> : null}
                    />
                    {this.props.activities.map((value) => (
                        <MenuItem
                            style={{textTransform: 'capitalize'}}
                            key={value}
                            checked={this.state.activitiesSelected && this.state.activitiesSelected.includes(value)}
                            value={value}
                            primaryText={(value === null || value === '') ? 'N/A' : value}
                            leftIcon={!(this.state.activitiesSelected && this.state.activitiesSelected.includes(value)) ? <CheckBoxIcon/> : null}
                        />))
                    }
                </SelectField>
            </div>
        );
    }

    allActivitiesSelected() {
        return this.state.activitiesSelected && this.state.activities.every(arr => this.state.activitiesSelected.includes(arr));
    }

    allFinancingSelected() {
        return this.state.selectedFinancingDate && this.state.financingList.every(item => this.state.selectedFinancingDate.includes(item));
    }

    /**
     * Appelé lorsque l'on change le filtre du type de carte de paiement
     * @param event
     * @param key
     * @param value
     */
    handleCardTypeChange(event, key, value) {
        let cardTypesSelected = value;
        if (value.includes("all")) {
            if (this.state.cardTypes.every(arr => value.includes(arr))) {
                cardTypesSelected = [];
            } else {
                cardTypesSelected = this.state.cardTypes;
            }
        }
        this.setState({
            cardTypesSelected: cardTypesSelected
        });
        this.state.cardTypeAction(cardTypesSelected);
    }

    /**
     * Appelé lorsque l'on change le filtre du type de l'activité
     * @param event
     * @param key
     * @param value
     */
    handleActivityChange(event, key, value) {
        let activitiesSelected = value;
        if (value.includes("all")) {
            if (this.state.activities.every(arr => value.includes(arr))) {
                activitiesSelected = [];
            } else {
                activitiesSelected = this.state.activities;
            }
        }
        this.setState({
            activitiesSelected: activitiesSelected
        });
        this.state.activityAction(activitiesSelected);
    }

}

export default ReportingHeader;



// WEBPACK FOOTER //
// ./src/components/tableComponent/ReportingHeader.js